<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">Forgot Password </h4>
  <button type="button" class="close" aria-label="Close" (click)="onCloseDialog()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="forgetPasswordForm" (ngSubmit)="onSubmit()">
    <div *ngIf="!isSuccess">
      <div class="form-group">
        <div style="padding-bottom:10px">Enter the email address or username you use to log in, and we'll send you an email to reset your password.</div>
        <label for="username">Email or Username</label>
        <input type="text" formControlName="username" class="form-control" placeholder="Enter Email or Username"  [ngClass]="{ 'is-invalid': submitted && f.username.errors }" autocomplete="on" />
        <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
          <div *ngIf="f.username.errors.required">Email or Username is required</div>
        </div>
        <div *ngIf="errormsg!=''" class="feedback-error">{{errormsg}}</div>
      </div>

      <div class="form-group">
        <button type="submit" [disabled]="loading || forgetPasswordForm.invalid" class="btn btn-primary">
          <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
          Send
        </button>
      </div>

    </div>

  </form>
  <div *ngIf="isSuccess">
    <div>
      Check your email to make a new password.
    </div>
    <div class="form-group mt-3">
      <button class="btn btn-primary" (click)="returnToLogin()">
        Return to login
      </button>
    </div>
  </div>

</div>




